import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex min-w-[1.5em] items-center justify-center rounded-xs border border-line-strong',
        'bg-surface-2 px-1.5 py-0.5 font-text text-caption leading-none text-ink-2',
        className,
      )}
    >
      {children}
    </kbd>
  )
}
